import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import authService from "../services/auth";
import "./Login.css";

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Invalid verification link. No token provided.");
      return;
    }

    // Verify the email
    authService
      .verifyEmail(token)
      .then(() => {
        setStatus("success");
        setMessage("Your email has been verified successfully!");
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.message || "Failed to verify email.");
      });
  }, [token]);

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Email Verification</h1>

        {status === "verifying" && (
          <div className="verifying-state">
            <div className="spinner"></div>
            <p>Verifying your email...</p>
          </div>
        )}

        {status === "success" && (
          <>
            <div className="success-message">
              <p>{message}</p>
              <p>You can now use all features of your account.</p>
            </div>
            <div className="login-footer">
              <p>
                <Link to="/dashboard">Go to Dashboard</Link>
              </p>
            </div>
          </>
        )}

        {status === "error" && (
          <>
            <div className="error-message">{message}</div>
            <div className="login-footer">
              <p>
                The verification link may have expired or already been used.
              </p>
              <p>
                <Link to="/login">Sign in</Link> to request a new verification
                email.
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
